<template>
  <div class="home">
    <Banner :data="getBrandBanner()" :single="getBrandBanner()?.length === 0" />
    <div class="container" v-if="!isNational">
      <div class="row  py-5">
        <div class="col-12"><h1 class="pstitle">Featured Inventory</h1></div>
      </div>
      <div class="row">
            <div v-for="boat in boats" :key="boat.id" class="col-12 col-sm-6 col-lg-3 mb-4">
                <boat-card :boat="boat" :showCompare="false"></boat-card>
            </div>
            <div class="col-12 mb-4" v-if="!boatsLoading && (boats == null || boats.length === 0)">
                <p class="no-boats-message">{{noNewBoats}}</p>
            </div>
      </div>  
  </div>
  </div>
</template>

<script>
import getBannerData from '../constants/banner.config';
import Banner from '../components/molecules/CarouselBanner.vue';
import getEndPoint, { featuredInventory } from "../constants/api.config";
import BoatCard from '../components/atoms/BoatCard';
import { noNewBoats } from "../constants/labels.config";

export default {
  name: "HomePage",
  components:{
    Banner,
    BoatCard
  },
  data(){
    return{
      brand:'',
      boats: [],
      boatsLoading: false,
      noNewBoats,
      isNational: false
    }
  },
  created() {
      this.isNational = window.IS_NATIONAL;
      if (this.isNational) {
          window.location.replace('./inventory/new');
      }
  },
  mounted(){
      this.brand = sessionStorage.getItem('brand');
      this.getFeaturedBoats();
  },
  methods:{
    getBrandBanner(){
      return getBannerData(sessionStorage.getItem('brand'), 'data');
    },
    getFeaturedBoats() {
        this.boatsLoading = true;
        this.axios.get(getEndPoint(featuredInventory) + 'DealerLocationID=' + window.DEALER_LOCATION.dealerLocationID + "&Brand=" + this.brand)
            .then((response) => {
                this.boats = response.data.data;
                this.boatsLoading = false;
            })
            .catch(err => {
                console.log(err);
                this.boatsLoading = false;
            })
    }
  }  
};
</script>
<style scoped>
img{
  max-width: 100%;
  max-height: 100%;
  margin: auto;
  display: block; /* remove extra space below image */
}
.box {
  display: flex;
  flex-direction: row;
}

</style>
